import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { PROPAGATION_STATUS, PropagationStoreStatus } from "@/utils/campaign-types";

interface PropagationStatusBadgeProps {
  status: PropagationStoreStatus;
  className?: string;
}

const STATUS_CONFIG: Record<
  PropagationStoreStatus,
  { variant: "default" | "secondary" | "destructive" | "outline"; label: string; className?: string }
> = {
  [PROPAGATION_STATUS.PENDING]: { variant: "outline", label: "Pendente" },
  [PROPAGATION_STATUS.IN_PROGRESS]: { variant: "secondary", label: "Em Progresso" },
  [PROPAGATION_STATUS.SUCCESS]: { variant: "default", label: "Sucesso", className: "bg-green-500 hover:bg-green-600" },
  [PROPAGATION_STATUS.FAILED]: { variant: "destructive", label: "Falha" },
};

export function PropagationStatusBadge({ status, className }: PropagationStatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <Badge variant={config.variant} className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
